export default [
  [`Размеры`, `2XS`, `XS`, `S`, `M`, `L`, `XL`, `2XL`],
  [`Длина`, `58`, `59`, `61`, `63`, `65`, `66`, `67`],
  [`Ширина`, `36`, `38`, `40`, `42`, `44`, `46`, `48`],
  [`Длина рукава`, `16`, `16`, `17`, `18`, `18`, `19`, `20`]
];
